<ng-select
  #ngSelect
  appendTo="body"
  class="selector-with-pagination"
  [ngClass]="classList"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (clear)="onClear($event)"
  [placeholder]="placeholder"
  [items]="items"
  [multiple]="multiple"
  [closeOnSelect]="closeOnSelect"
  [searchable]="true"
  [loading]="loading"
  [(ngModel)]="value"
  [minTermLength]="0"
  [disabled]="isDisabled"
  [compareWith]="compareFn"
  [typeahead]="quickSearchTermInput$"
  loadingText="{{ 'CA::Loading' | abpLocalization }}..."
  bindLabel="name">
  <ng-template *ngIf="headerInfo" ng-header-tmp>
    <div [ngStyle]="headerInfoStyle" [innerHtml]="headerInfo"></div>
  </ng-template>
  <ng-template ng-footer-tmp>
    <div class="w-100 d-flex d-flex flex-row justify-content-start align-items-center">
      <mat-paginator
        class="d-flex flex-row justify-content-row"
        style="flex: 0 0 350px"
        [length]="totalCount"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"></mat-paginator>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="query-selection-panel-query-name">
      <div class="truncate-text" [ngbTooltip]="item.name" showTooltipIfTruncated container="body">
        {{ item.name }}
      </div>
      <div class="query-selection-panel-info-button">
        <div
          [ngStyle]="{
            color: !item.lastQueryVersionIndexed ? 'rgb(255, 157, 9)' : 'rgb(0, 0, 0)',
          }"
          style="vertical-align: top"
          #popover="ngbPopover"
          [ngbPopover]="previewQueryPopContent"
          [popoverTitle]="previewQueryPopTitle"
          popoverClass="query-preview-popover"
          placement="right auto"
          triggers="manual"
          container="body"
          [autoClose]="'outside'"
          (click)="toggleQueryPreviewPopover(popover, item, $event)">
          <div *ngIf="isQueryPreviewLoading && item.id === previewQueryId; else loaded">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-select>

<ng-template
  #previewQueryPopContent
  let-queryItems="queryItems"
  let-categories="categories"
  let-query="query">
  <ca-query-detail-builder
    #builder
    [isReadonly]="true"
    (abpInit)="builder.loadQueryItems(queryItems, categories, query)"></ca-query-detail-builder>
</ng-template>

<ng-template #previewQueryPopTitle let-query="query">
  <div
    *ngIf="query.isCategory"
    class="badge category-badge ps-1"
    [ngStyle]="colorUtils.getColors(query.categoryColor)"
    [title]="query.categoryName">
    {{ query.categoryName }}
  </div>
</ng-template>

<ng-template #loaded>
  <i class="fa-sharp fa-light fa-circle-info"></i>
</ng-template>
